<div class="fx-row fx-wrap align-items-center justify-content-between">
  <app-back></app-back>
  <div class="fx-row fx-wrap align-items-center justify-content-between fx-flex-100">
    <div class="fx-column fx-flex">
      <span class="page-title">{{'CASE_DECLARE.TITLE' | translate}}</span>
      <span class="page-subtitle">{{'CASE_DECLARE.SUBTITLE' | translate}}</span>
    </div>
    <app-quota-bound-button quota="cases">
      <button class="main-button ml-20" (click)="declare()"
        [disabled]="isStepDisabled(CaseStepEnum.REFERENCE) || loading"
        [class.disabled]="isStepDisabled(CaseStepEnum.REFERENCE) || loading" aclBasedElement resource="CASE"
        [scopes]="['C']">
        <div class="fx-row align-items-center justify-content-center">
          {{'CASES_LIST.OPEN_CASE' | translate}}
        </div>
      </button>
    </app-quota-bound-button>
  </div>
</div>
<mat-divider class="mv-20"></mat-divider>
<mat-card>
  <div class="fx-row fx-wrap align-items-center justify-content-start">
    <div class="fx-row fx-wrap align-items-center justify-content-between fx-flex-100 mb-16 ">
      <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex">
        <div class="step" [class.disabled]="isStepDisabled(CaseStepEnum.CASE_TYPE)">
          <span class="text white bold">
            1
          </span>
        </div>
        <div class="fx-column ml-10 fx-flex">
          <span class="text bold">{{'CASE_DECLARE.SELECT_CASE_TYPE' | translate}}</span>
          <span class="small light">{{'CASE_DECLARE.SELECT_CASE_TYPE_HINT' | translate}}</span>
        </div>
      </div>
      <app-select #caseTypeSelect initial="none" label="{{'CASE.TYPE' | translate}}" [options]="caseTypes"
        [multiple]="false" (change)="onCaseTypeChange($event)" [emitOnInit]="false"
        [disabled]="isStepDisabled(CaseStepEnum.CASE_TYPE)" style="width:210px;"></app-select>
    </div>
    <div class="fx-row fx-wrap align-items-center justify-content-between fx-flex-100 mb-16">
      <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex">
        <div class="step" [class.disabled]="isStepDisabled(CaseStepEnum.TRADEMARK)">
          <span class="text white bold">
            2
          </span>
        </div>
        <div class="fx-column ml-10 fx-flex">
          <span class="text bold">{{'CASE_DECLARE.SELECT_TRADEMARK' | translate}}</span>
          <span class="small light">{{'CASE_DECLARE.SELECT_TRADEMARK_HINT' | translate}}</span>
        </div>
      </div>
      <app-trademark-select label="{{'ENTITIES.TRADEMARK' | translate}}" [multiple]="false" [search]="true"
        initial="none" (change)="onTrademarkChange($event)" [emitOnInit]="false" style="width:210px;"
        [disabled]="isStepDisabled(CaseStepEnum.TRADEMARK)"></app-trademark-select>
    </div>
    <div class="fx-row fx-wrap align-items-center justify-content-between fx-flex-100 mb-16">
      <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex">
        <div class="step" [class.disabled]="isStepDisabled(CaseStepEnum.NICE_CLASS)">
          <span class="text white bold">
            3
          </span>
        </div>
        <div class="fx-column ml-10 fx-flex">
          <span class="text bold">{{'CASE_DECLARE.SELECT_CLASSES' | translate}}</span>
          <span class="small light">{{'CASE_DECLARE.SELECT_CLASSES_HINT' | translate}}</span>
        </div>
      </div>
      <app-nice-select #niceSelect label="{{'ENTITIES.NICE_CLASSIFICATION' | translate}}" [multiple]="true"
        [search]="false" initial="none" (change)="onNiceClassificationChange($event)" [emitOnInit]="false"
        style="width:210px;" [disabled]="isStepDisabled(CaseStepEnum.NICE_CLASS)"
        [restrict]="trademark?.niceClassification ?? []"></app-nice-select>
    </div>
    <div class="fx-row fx-wrap align-items-center justify-content-between fx-flex-100 mb-16"
      *ngIf="_trademark && niceClassification.length > 0">
      <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex">
        <!-- <div class="step outline" [class.disabled]="isStepDisabled(CaseStepEnum.NICE_CLASS)"> -->
        <mat-icon class="main" fontSet="material-icons-outlined">subdirectory_arrow_right</mat-icon>
        <!-- </div> -->
        <div class="fx-column ml-10 fx-flex">
          <span class="text bold">{{'CASE_DECLARE.SELECT_PRODUCTS_SERVICES' | translate}}</span>
          <span class="small light">{{'CASE_DECLARE.SELECT_PRODUCTS_SERVICES_HINT' | translate}}</span>
        </div>
      </div>
      <app-product-service-select #productServiceSelect label="{{'ENTITIES.PRODUCTS_SERVICES' | translate}}"
        [multiple]="true" [search]="true" style="width:210px;" (change)="onProductServiceChange($event)"
        [emitOnInit]="false" [trademarks]="[_trademark]" [niceClassification]="niceClassification" [editTmNice]="false"
        [initial]="'all'">
      </app-product-service-select>
    </div>
    <div class="fx-row fx-wrap align-items-center justify-content-between fx-flex-100 mb-16 ">
      <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex">
        <div class="step" [class.disabled]="isStepDisabled(CaseStepEnum.OFFICE)">
          <span class="text white bold">
            4
          </span>
        </div>
        <div class="fx-column ml-10 fx-flex">
          <span class="text bold">{{'CASE_DECLARE.SELECT_OFFICE' | translate}}</span>
          <span class="small light">{{'CASE_DECLARE.SELECT_OFFICE_HINT' | translate}}</span>
        </div>
      </div>
      <app-property-office-select #propertyOfficeSelect label="{{'ENTITIES.PROPERTY_OFFICE' | translate}}"
        style="width:210px;" [search]="true" (change)="onPropertyOfficeChange($event)"
        [disabled]="isStepDisabled(CaseStepEnum.OFFICE)"></app-property-office-select>
    </div>

    <div class="fx-row fx-wrap align-items-start justify-content-between fx-flex-100 mb-16 ">
      <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex">
        <div class="step" [class.disabled]="isStepDisabled(CaseStepEnum.PERIOD)">
          <span class="text white bold">
            5
          </span>
        </div>
        <div class="fx-column ml-10 fx-flex">
          <span class="text bold">{{'CASE_DECLARE.SELECT_PERIOD' | translate}}</span>
          <span class="small light">{{'CASE_DECLARE.SELECT_PERIOD_HINT' | translate}}</span>
          <span class="small main" *ngIf="type">{{_periodMessage()}}</span>
          <div class="fx-row align-items-center justify-content-start small" *ngIf="durationWarning()">
            <mat-icon class="red mr-5" fontSet="material-icons-outlined" inline>error_outline</mat-icon>
            <span class="small red">{{_exceedMessage()}}</span>
          </div>
        </div>
      </div>
      <div class="fx-column period-group">
        <app-datepicker placeholder="{{'CASE.PERIOD_FROM' | translate}}" [value]="period.start"
          (change)="onPeriodStartChange($event)" [disabled]="isStepDisabled(CaseStepEnum.PERIOD)" style="width: 210px;">
        </app-datepicker>
        @if (period.start) {
        <app-datepicker placeholder="{{'CASE.PERIOD_TO' | translate}}" [value]="period.end"
          (change)="onPeriodEndChange($event)" [disabled]="isStepDisabled(CaseStepEnum.PERIOD)" style="width: 210px;">
        </app-datepicker>
        }
      </div>
    </div>
    <div class="fx-row fx-wrap align-items-center justify-content-between fx-flex-100 mb-16 ">
      <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex">
        <div class="step" [class.disabled]="isStepDisabled(CaseStepEnum.LANGUAGE)">
          <span class="text white bold">
            6
          </span>
        </div>
        <div class="fx-column ml-10 fx-flex">
          <span class="text bold">{{'CASE_DECLARE.SELECT_LANG' | translate}}</span>
          <span class="small light">{{'CASE_DECLARE.SELECT_LANG_HINT' | translate}}</span>
        </div>
      </div>
      <app-select initial="none" label="{{'CASE.LANG' | translate}}" [options]="langs" [multiple]="false"
        (change)="onLangChange($event)" [emitOnInit]="false" [disabled]="isStepDisabled(CaseStepEnum.LANGUAGE)"
        style="width:210px;"></app-select>
    </div>
    <div class="fx-row fx-wrap align-items-center justify-content-between fx-flex-100 ">
      <div class="fx-row fx-wrap align-items-center justify-content-start fx-flex">
        <div class="step" [class.disabled]="isStepDisabled(CaseStepEnum.REFERENCE)">
          <span class="text white bold">
            7
          </span>
        </div>
        <div class="fx-column ml-10 fx-flex">
          <span class="text bold">{{'CASE_DECLARE.SET_IDENTIFIER' | translate}}</span>
          <span class="small light">{{'CASE_DECLARE.SET_IDENTIFIER_HINT' | translate}}</span>
        </div>
      </div>
      <app-input placeholder="{{'CASE_DECLARE.IDENTIFIER' | translate}}..." style="width:210px;" type="text"
        [(value)]="identifier" [disabled]="isStepDisabled(CaseStepEnum.REFERENCE)"></app-input>
    </div>
  </div>
</mat-card>